// Tunable input settings (§8). Touch and stick want different curves, so the
// dead-zone / sensitivity live here and can be surfaced in a settings UI later.

export const InputSettings = {
  /** Overall steer responsiveness multiplier. */
  steerSensitivity: 1.0,
  /** Analog stick / virtual-stick dead-zone. */
  deadzone: 0.14,
  /** Mouse / right-stick camera nudge strength. */
  cameraSensitivity: 1.0,
};

/** Apply dead-zone then a mild expo curve for finer control near center. */
export function shapeAxis(raw: number): number {
  const dz = InputSettings.deadzone;
  const sign = Math.sign(raw);
  const mag = Math.abs(raw);
  if (mag < dz) return 0;
  const norm = (mag - dz) / (1 - dz);
  const expo = norm * (0.6 + 0.4 * norm); // gentle expo
  return sign * Math.min(1, expo) * InputSettings.steerSensitivity;
}
